import React from "react";
import { useSelector } from "react-redux";
import { Container, Grid } from "@mui/material";
import BreadcrumbBuilder from "./BreadcrumbBuilder";
import RMSWidget from "./RMSWidget";
import CENTWidget from "../CENT/CENTWidget";
import MyAppraiseesCard from "./Appraisee/MyAppraiseesCard";

import WelcomeCard from "../CMS/WelcomeCard";

import { getRmsAppCode } from "../../../reducers";

function Dashboard() {
    const appCode = useSelector(getRmsAppCode);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <WelcomeCard appCode={appCode} />
                </Grid>

                <Grid item xs={12}>
                    <RMSWidget appCode={appCode} />
                </Grid>

                <Grid item sm={12} md={6} lg={6} className="card-grid-item">
                    <CENTWidget appCode={appCode} />
                </Grid>

                <Grid item sm={12} md={6} lg={6} className="card-grid-item">
                    <MyAppraiseesCard appCode={appCode} />
                </Grid>
            </Grid>
        </Container>
    );
}

export default Dashboard;
